import type { CapabilityDefinitionSnapshotV1 } from '../definition/consumer/contract';

/** Current page-session reads only. A repeated identity replaces its snapshot in place. */
export function rememberDefinition(
  collection: readonly CapabilityDefinitionSnapshotV1[],
  snapshot: CapabilityDefinitionSnapshotV1,
): readonly CapabilityDefinitionSnapshotV1[] {
  const index = collection.findIndex((entry) => entry.capabilityId === snapshot.capabilityId);
  return index < 0
    ? [...collection, snapshot]
    : collection.map((entry, position) => (position === index ? snapshot : entry));
}

export interface DefinitionFilter {
  readonly text: string;
  readonly type: string;
  readonly status: string;
}

export function filterDefinitions(
  collection: readonly CapabilityDefinitionSnapshotV1[],
  filter: DefinitionFilter,
): readonly CapabilityDefinitionSnapshotV1[] {
  const text = filter.text.trim().toLocaleLowerCase();
  return collection.filter(
    (entry) =>
      (!text || `${entry.capabilityId}\n${entry.displayName}`.toLocaleLowerCase().includes(text)) &&
      (!filter.type || entry.capabilityType === filter.type) &&
      (!filter.status || entry.definitionStatus === filter.status),
  );
}

export function definitionFilterOptions(collection: readonly CapabilityDefinitionSnapshotV1[]) {
  return {
    types: [...new Set(collection.map((entry) => entry.capabilityType))].sort(),
    statuses: [...new Set(collection.map((entry) => entry.definitionStatus))].sort(),
  };
}
